import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Vazio } from './estados';

/** Comunicação unificada (04/11): a aba de um canal que ainda não tem conector (Telegram e Slack). */
export function CanalEmBreve() {
  const { t } = useTranslation();
  const { canal = '' } = useParams();
  if (canal !== 'telegram' && canal !== 'slack') return <Vazio titulo={t('estados.naoEncontrado')} texto="" />;
  return <Vazio titulo={t(`comunicacao.emBreve.${canal}`)} texto={t('comunicacao.emBreveTexto')} />;
}
